import { render, staticRenderFns } from "./TModalSection.vue?vue&type=template&id=5dbd0a6a&"
import script from "./TModalSection.vue?vue&type=script&lang=js&"
export * from "./TModalSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports